import { getApiUrl } from "../utils/general.js";
import axios from "axios";

const getAuthToken = () => {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith("Q8TechAuth=")) {
      return cookie.substring("Q8TechAuth=".length, cookie.length);
    }
  }
  return null;
};

const UserService = {
  login: async (accessToken) => {
    try {
      const { data, status } = await axios.post(
        `${getApiUrl()}/auth/login`,
        null,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          timeout: 30000,
        }
      );

      return { success: status === 200, data };
    } catch (error) {

      if (error.code === "ECONNABORTED") {
        throw new Error(
          "Il server non risponde. Verifica che il servizio sia attivo."
        );
      }

      if (error.response) {
        switch (error.response.status) {
          case 401:
            throw new Error(
              "Accesso non autorizzato. Verifica le tue credenziali."
            );
          case 403:
            throw new Error("Non hai i permessi necessari per accedere.");
          case 404:
            throw new Error(
              "Servizio di login non disponibile. Contatta l'amministratore."
            );
          default:
            throw new Error("Errore durante il login. Riprova più tardi.");
        }
      }

      throw new Error(
        "Server non raggiungibile. Verifica che il servizio sia attivo."
      );
    }
  },

  getUserInfo: async () => {
    try {
      const token = getAuthToken();
      const { data } = await axios.get(`${getApiUrl()}/user/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw error.response.data;
      } else if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  getUsers: async () => {
    try {
      const { data } = await axios.get(`${getApiUrl()}/user/users`);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw error.response.data;
      } else if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  createUser: async (userData) => {
    try {
      const { data } = await axios.post(`${getApiUrl()}/user/create`, userData);
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw error.response.data;
      } else if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  deleteUser: async (userId) => {
    try {
      const { data } = await axios.delete(
        `${getApiUrl()}/user/delete/${userId}`
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw error.response.data;
      } else if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },

  updateRoles: async (rolesData) => {
    try {
      const { data } = await axios.post(
        `${getApiUrl()}/userrole/update`,
        rolesData
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw error.response.data;
      } else if (error instanceof Error) {
        throw new Error(error.message);
      } else {
        throw new Error(String(error));
      }
    }
  },
};

export default UserService;
